import { memo, useState } from 'react';
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { BzButton, BzChip, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzDropdown } from "../../../../components";
import ConfirmBuyOrder from './ConfirmBuyOrder';
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../../../redux/actions/modals";

const objDropdownOptions = {
    folioNo: ['49914514', '6475832591'],
    transactionTypes: ['Demat', 'Online'],
};
const PlaceNfoOrder = ({ nfoDetails }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const [quantity, setQuantity] = useState(0);
    const handleOnPlaceNfoOrder = () => {
        dispatch(handleModal([{ 'PLACE_NFO_ORDER': false }, { 'CONFIRM_BUY_ORDER': true }]));

    };
    const handleClose = () => {
        dispatch(handleModal([{ "PLACE_NFO_ORDER": false }]));
    };

    return (<>
        <BzModal size='lg' show={modals['PLACE_NFO_ORDER']} onHide={handleClose} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size5 color-text'>Place Your NFO Order</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div onClick={handleClose} className='icon-16 icon-close icon-dark ms-3'></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>

            <BzModalBody className='bdr-btm'>
                {/* Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start */}
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col>
                            <Row className='g-0 mb-2'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div className='font-medium font-size5 color-text me-2'>{nfoDetails?.scheme_name}</div>
                                    <div className='chips-wrap'>
                                        <BzChip className='chips primary-chip'>{nfoDetails?.scheme_type}</BzChip>
                                    </div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='flex-column justify-content-end'>
                                        <Row className='g-0'>
                                            <Col className='d-flex justify-content-end align-items-center'>
                                                <div className='font-regular font-size4 color-subtext'>Min. Investment</div>
                                                <div className='icon-16 icon-info icon-dark ms-2'>&nbsp;</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col className='d-flex justify-content-end align-items-center'>
                                                <div className='font-medium font-size4 color-sub'>&#8377;{nfoDetails?.min_purchase_amount_for_new_investors}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='g-0 mt-2'>
                        <Col md={3} className='d-flex flex-wrap justify-content-start align-items-center me-5'>
                            <div className='font-regular font-size3 color-subtext mb-1'>Amount to Invest</div>                            
                            <div className='input-group postion-relative'>
                                <div onClick={() => { if (quantity > 0) setQuantity(current => current - 1); }} className='icon-12 icon-order-decrease input-number-left-wrap'></div>
                                <BzInputText type="number" className='text-center p-0 font-regular' placeholder='1' onChange={(e) => { setQuantity(e.target.value); }} value={quantity}/>
                                <div onClick={() => { setQuantity(current => parseInt(current) + 1); }} className='icon-12 icon-order-increase input-number-right-wrap'></div>
                            </div>                            
                        </Col>
                        <Col md={2} className='flex-wrap justify-content-start align-items-center me-4'>
                            <div className='font-regular font-size3 color-subtext mb-1'>Transaction</div>
                            <div className='Bzmodalselect-dropdown'>
                                <BzDropdown size="sm">
                                    <Dropdown.Toggle className='btn-default'>{objDropdownOptions?.transactionTypes?.[0]}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {objDropdownOptions.transactionTypes.map((eachOption, i) => (
                                            <Dropdown.Item key={i} value={eachOption}>{eachOption}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </BzDropdown>
                            </div>
                        </Col>
                        <Col md={2} className='flex-wrap justify-content-start align-items-center me-3'>
                            <div className='font-regular font-size3 color-subtext mb-1'>Folio No</div>
                            <div className='Bzmodalselect-dropdown'>
                                <BzDropdown size="sm">
                                    <Dropdown.Toggle className='btn-default'>{objDropdownOptions?.folioNo?.[0]}</Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {objDropdownOptions.folioNo.map((eachOption, i) => (
                                            <Dropdown.Item key={i} value={eachOption}>{eachOption}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </BzDropdown>
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-2 pb-4'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='icon-16 icon-info icon-dark me-2'>&nbsp;</div>
                            <div className='font-medium font-size1 color-subtext pt-1'>Min. amount is &#8377;{nfoDetails?.min_purchase_amount_for_new_investors}</div>
                        </Col>
                    </Row>
                </Container>
                {/* Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End */}
            </BzModalBody>

            <BzModalFooter className='p-3'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={9} className='d-flex justify-content-start align-items-center'>
                            <div className='d-flex justify-content-start align-items-center me-3'>
                                <div className='font-medium font-size4 color-text'>Mandate</div>
                                <div className='icon-16 icon-info icon-dark ms-2'></div>
                            </div>
                            <div className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-textual-link-withicon cursor-pointer'>Add new Mandate</div>
                                <div className='icon-12 icon-add icon-primary ms-2'></div>
                            </div>
                        </Col>
                        <Col md={3} className='d-flex justify-content-end align-items-center'>
                            <BzButton className='btn btn-md btn-positive' onClick={handleOnPlaceNfoOrder}>PLACE ORDER</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>

        <ConfirmBuyOrder nfoDetails={nfoDetails} />

    </>);
};
export default memo(PlaceNfoOrder);